import { updateBasketTimer } from "./basket";

const ticketingApis = '/actions/red61-ticketing/ajax';

export function apiGet(endpoint, queryParams = {}) {
    let url = `${ticketingApis}/${endpoint}`;
    let keys = Object.keys(queryParams);
    let params = [];

    if (keys.length) {
        for (let key of keys) {
            params.push(`${encodeURIComponent(key)}=${encodeURIComponent(queryParams[key])}`);
        }

        url = `${url}?${params.join('&')}`;
    }

    return fetch(url,
        {
            method: 'GET',
        }
    );
}

export function apiPost(endpoint, body = {}) {
    let url = `${ticketingApis}/${endpoint}`;
    let content = null;

    if (body instanceof Object) {
        content = new FormData();
        content.set(window.csrfTokenName, window.csrfTokenValue);

        for (let key in body) {
            content.set(key, body[key]);
        }
    } else if (body instanceof FormData) {
        content = body;
    }

    return fetch(url, {
        method: 'POST',
        body: content
    });
}

export function clearFormErrors(form) {
    form.querySelectorAll(`.form-error`).forEach((ele) => ele.innerHTML = null);
}

export function updateFormErrors(form,errors) {
    for (let field in errors) {
        const errorEle = form.querySelector(`*[name="${field}"]~div.form-error`);

        if (errorEle) {
            errorEle.innerHTML = null;

            for ( let error of errors[field] ) {
                const row = document.createElement('div');
                row.innerText = error;
                errorEle.appendChild(row);
            }
        }
    }
}

export function setFormSubmitButtonEnabled(form, enabled) {
    const submitButton = form.querySelector('button[type="submit"]');
    if (submitButton) {
        submitButton.disabled = !enabled;
    }
}

export function fetchForm(form) {
    const url = form.getAttribute('action');
    const method = form.getAttribute('method');
    const formData = new FormData(form);

    setFormSubmitButtonEnabled(form, false);

    return fetch(url, {
        method: method,
        body: formData
    }).then(async (resp) => {
        const response = await resp.json();

        if (response) {
            // clear any existing errors
            clearFormErrors(form);

            // Broadcast cart timer
            updateBasketTimer(resp.basketExpiry, resp.basketItemCount);

            if (response.result) {
                return response;
            }

            if (response.errors) {
                // set our field errors
                updateFormErrors(form, response.errors);
            }

            if (response.error) {
                // singular error message
                const errorField = form.querySelector('.form-error.general-error');

                if (errorField) {
                    errorField.innerText = response.error;
                }
            }
        }

        let error = new Error('Errors encountered while processing the AJAX request');
        error.response = response;

        setFormSubmitButtonEnabled(form, true);
        throw error;
    });
}
